<template>
  <span>
    <v-row class="mx-auto" justify="end">
      <v-col cols="auto">
        <v-btn
          color="primary"
          dark
          elevation="1"
          text
          medium
          :loading="downloading"
          @click="exportar()"
        >
          <v-icon left size="30px">
            mdi-microsoft-excel
          </v-icon>
          Exportar XLSX
        </v-btn>
      </v-col>
    </v-row>
    <v-row class="mx-auto">
      <v-col cols="12" class="mt-2">
        <v-data-table
          dense
          item-key="chave"
          :headers="headers"
          :items="itemsComChave"
          :headerProps="{ sortByText: 'Ordenar Por' }"
          :footer-props="{
            itemsPerPageText: 'Itens por Página',
            itemsPerPageOptions: [10, 25, 50, 100],
          }"
          no-data-text="Nenhuma combinação ausente encontrada"
          no-results-text="Nenhum registro correspondente encontrado"
          :mobile-breakpoint="10"
        >
          <template v-slot:[`item.serv_005`]="{ item }">
            {{ item.serv_005 }}<template v-if="nomesServicos[item.serv_005]"> - {{ nomesServicos[item.serv_005] }}</template>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </span>
</template>

<script>
  import IndicadoresServicosV2Service from "@/services/IndicadoresServicosV2Service.js";

  export default {
    name: "ServicosV2VisaoDetalhadaCobertura",
    props: {
      competencia_de: {
        type: String,
        required: true,
      },
      competencia_ate: {
        type: String,
        required: true,
      },
      nomesServicos: {
        type: Object,
        required: true,
      },
      items: {
        type: Array,
        required: true,
      },
    },
    data: () => ({
      headers: [
        { text: "Serviço", value: "serv_005" },
        { text: "Competência", value: "competencia" },
        { text: "Código IBGE", value: "serv_002" },
        { text: "Município", value: "nome_municipio" },
      ],
      downloading: false,
    }),
    computed: {
      itemsComChave() {
        return this.items.map((item) => ({
          ...item,
          chave: `${item.serv_005}-${item.serv_002}-${item.competencia}`,
        }));
      },
    },
    methods: {
      exportar() {
        this.downloading = true;

        IndicadoresServicosV2Service.downloadArquivoCombinacoesAusentes(
          this.competencia_de,
          this.competencia_ate
        )
          .then((res) => {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "Cobertura_Ausente_Servicos_V2.xlsx");
            document.body.appendChild(link);
            link.click();
          })
          .catch((err) => {
            this.$toast.error("Erro no download do arquivo.", "", {
              position: "topRight",
              timeout: 5000,
            });
            throw err;
          })
          .finally(() => (this.downloading = false));
      },
    },
  };
</script>

<style></style>
